import { Component, OnInit } from '@angular/core';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { DatagridService, PagedResultGeneric, TranslationService, NotificationService } from 'src/app/shared';
import { CouponSearchDto } from '../../shared/dto/coupon-search.dto';
import { CouponDto } from '../../shared/dto/coupon.dto';
import { CouponService } from '../../shared/coupon.service';
import { MenuItem, ConfirmationService } from 'primeng/api';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { ConfigService } from 'src/app/config/shared/config.service';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';

@Component({
  selector: 'wl-coupon-search-grid',
  templateUrl: './coupon-search-grid.component.html',
  styleUrls: ['./coupon-search-grid.component.less'],
    standalone: false
})
export class CouponSearchGridComponent extends LazySelectableTableComponent<CouponSearchDto, CouponDto> implements OnInit {
  private _rowMenuItems = new Map<number, MenuItem[]>();
  constructor(
    datagridService: DatagridService,
    private _couponService: CouponService,
    private _translationService: TranslationService,
    private _notificationService: NotificationService,
    private _navigationService: NavigationService,
    private _confirmationService: ConfirmationService,
    private _configService: ConfigService,
    private _configServiceService: ConfigServiceService
  ) {
    super('CouponId', datagridService);
  }

  ngOnInit(): void {}

  fetchResults(): Promise<PagedResultGeneric<CouponDto>> {
    return this._couponService.search(this.searchParams);
  }

  clear() {
    this.searchParams = new CouponSearchDto();
    this.search();
  }

  couponChanged(coupon: CouponDto) {
    this._couponService
      .update(coupon)
      .then(() => {
        this._notificationService.translateSuccess('coupons.search.coupon-updated-message');
      })
      .catch((err) => {
        this._notificationService.httpError(err);
        this.search();
      });
  }

  actionItemsForCoupon(coupon: CouponDto) {
    if (!this._rowMenuItems.has(coupon.CouponId)) {
      this._rowMenuItems.set(coupon.CouponId, [
        {
          label: this._translationService.getInstantTitlecase('common.edit'),
          command: () => this.editCoupon(coupon),
        },
        {
          label: this._translationService.getInstantTitlecase('common.delete'),
          command: () => this.deleteCoupon(coupon),
        },
      ]);
    }
    return this._rowMenuItems.get(coupon.CouponId);
  }

  private editCoupon(coupon: CouponDto) {
    Promise.all([this._configService.hasBetaFeatureEnabled('MemberPortal'), this._configServiceService.getWebComponentSettings()]).then(
      ([portal, webComp]) => {
        if (portal || webComp.RedirectLegacyToNew) {
          this._navigationService.navigateToModernCouponAdmin(coupon.ProfileId);
        } else {
          this._navigationService.navigateToLegacyCouponCrudPage(coupon.ProfileId);
        }
      }
    );
  }

  private deleteCoupon(coupon: CouponDto) {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('coupons.search.confirm-delete-message'),
      key: 'deleteCouponCD',
      accept: () => {
        this.loading = true;
        this._couponService
          .delete(coupon.CouponId)
          .then(() => {
            this._notificationService.translateSuccess('coupons.search.coupon-deleted-message');
            this.search();
          })
          .catch((error) => {
            this._notificationService.httpError(error);
          });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
